import { Button, ButtonProps } from "antd";
import { Link } from "react-router-dom";
import "./style.css";

interface YudlButtonProps extends ButtonProps {
  variant?: "primary" | "secondary" | "secondary-light" | "outline-primary" | "orange";
  buttonRole?: "button" | "anchor" | "link";
  link?: string;
}

const YudlButton = ({
  variant = "primary",
  children,
  loading,
  disabled,
  className,
  link,
  buttonRole = "button",
  onClick,
  ...props
}: YudlButtonProps) => {
  if (buttonRole === "anchor") {
    return (
      <a
        className={` d-flex align-items-center justify-content-center  ${
          className ? className : ""
        } appbtn appbtn-${variant}`}
        onClick={disabled || loading ? () => {} : onClick}
        href={link}
        {...props}
      >
        {children}
      </a>
    );
  }

  if (buttonRole === "link") {
    return (
      <Link
        className={` d-flex align-items-center justify-content-center  ${
          className ? className : ""
        } appbtn appbtn-${variant}`}
        onClick={disabled || loading ? () => {} : onClick}
        to={link || "/"}
        {...props}
      >
        {children}
      </Link>
    );
  }

  return (
    <Button
      className={` d-flex align-items-center justify-content-center  ${
        className ? className : ""
      } appbtn appbtn-${variant}`}
      onClick={disabled || loading ? () => {} : onClick}
      loading={loading}
      {...props}
    >
      {children}
    </Button>
  );
};

export default YudlButton;
